export default phone => (phone ? phone
  .slice(0, phone.length - 5)
  .concat('XXXXX')
  .replace(/[^0-9X+]/g, '')
  .replace(/(\d{3})(\d{3})(\d{4})(\d{3})/, '$1 $2 $3 $4') : phone);



// WEBPACK FOOTER //
// ./src/filter/phone.js